import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { ProductColorService } from './product-color.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
@Component({
  selector: 'app-product-color',
  templateUrl: './product-color.component.html',
  styleUrls: ['./product-color.component.scss']
})
export class ProductColorComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'color','color_code', 'status', 'action',];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  isLoading: Subject<boolean> = new Subject<boolean>();

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  productColorForm: FormGroup;
  public searchInput = new FormControl("");

  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private productColorService: ProductColorService) {
    this.productColorForm = this.fb.group({
      productColor: ['', Validators.required],
      status: ['', Validators.required],
      colorCode:['',Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.productColorForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    console.log(this.selectedObject);
    
    this.productColorForm.patchValue({
      productColor: object.color,
      status: object.status ? 1 : 0,
      colorCode:object.color_code
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const colorMatch = data.color.toLowerCase().includes(filter);
      const colorCodeMatch = data.color_code.toLowerCase().includes(filter);
      return colorMatch || colorCodeMatch;
    };
      this.dataSource.filter = filterValue;
  }

  clearSearch() {
    this.searchInput.setValue(''); // Clear the search input
    this.applyFilter();
  }

  create() {
    this.submitted = true
    if (this.productColorForm.valid) {
      const productColorData = this.productColorForm.value;
      let obj = {
        "color": productColorData.productColor,
        "color_code":productColorData.colorCode,
        "status": parseInt(productColorData.status),
        "flag": "create"
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.productColorService.productColorCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Product color created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.productColorForm.valid) {
      const productColorData = this.productColorForm.value;
      let obj = {
        "color": productColorData.productColor,
        "status": parseInt(productColorData.status),
        "flag": "update",
        "id": this.selectedObject.id
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.productColorService.productColorCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Product color updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.productColorForm.patchValue({
      productColor: '',
      status: '',
      colorCode:''
    });
  }

  allowAplhabetsOnly(event: any) {
    this.sharedService.allowAlphabetsOnly(event);
  }

  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.productColorService.productColorCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        console.log(this.ELEMENT_DATA);
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }
}
